import { useEffect, useState } from "react"

import { Container, Modal } from "@pamf-my/ui"
import SAccountListType from "@/services/account/list-type"
import { IAccountProduct, IAccountProductWithTransaction } from "@pamf-my/types"
import Table from "@/components/table"
import { getCoreRowModel, useReactTable } from "@tanstack/react-table"
import UpdateAccountTransactionForm from "./update-transaction"

const AccountPage = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<IAccountProductWithTransaction[]>([])
  const [transactionModalOpen, setTransactionModalOpen] = useState(false)
  const [selectedAccount, setSelectedAccount] =
    useState<IAccountProductWithTransaction | null>(null)

  useEffect(() => {
    setLoading(true)
    SAccountListType()
      .then(res => {
        if (res.success) {
          setData(res.data)
        } else {
          console.error(res)
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const table = useReactTable<IAccountProductWithTransaction>({
    data,
    getCoreRowModel: getCoreRowModel(),
    columns: [
      {
        accessorKey: "productCode",
        header: "Code",
      },
      {
        accessorKey: "productName",
        header: "Nom",
      },
      {
        accessorKey: "transactional",
        header: "Transaction",
        cell: info => (
          <div className="flex justify-between">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                value=""
                className="sr-only peer"
                checked={info.getValue()}
                onChange={() => {
                  setSelectedAccount(info.row.original)
                  setTransactionModalOpen(true)
                }}
              />
              <div className="w-9 h-5 bg-neutral hover:ring rounded-full peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white  after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary"></div>
            </label>
          </div>
        ),
      },
    ],
  })

  return (
    <Container>
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <Table
          noPagination
          table={table}
          filterOn="productCode"
          tableLoading={loading}
        />
      )}

      <Modal
        title="Transaction"
        setOpen={transactionModalOpen}
        onClose={() => setTransactionModalOpen(false)}
      >
        <UpdateAccountTransactionForm
          productCode={selectedAccount?.productCode || ""}
          transactional={selectedAccount?.transactional || false}
          onClose={updated => {
            setTransactionModalOpen(false)
            if (updated) {
              SAccountListType()
                .then(res => {
                  if (res.success) {
                    setData(res.data)
                  } else {
                    console.error(res)
                  }
                })
                .finally(() => {
                  setLoading(false)
                })
            }
          }}
        />
      </Modal>
    </Container>
  )
}

export default AccountPage
